exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-container[data-v-be6b7bae]{white-space:nowrap;position:relative;overflow:hidden;width:100%}.scroll-container[data-v-be6b7bae]  .el-scrollbar__bar{bottom:0px}.scroll-container[data-v-be6b7bae]  .el-scrollbar__wrap{height:49px}", ""]);

// exports
